module.exports = __webpack_public_path__ + "img/gauranteelogo.57c946d5.jpg";